<template>
  <div class="back-button-bar is-hidden-desktop" v-if="selectedUni">
      <a class="navbar-item" href="#" @click.prevent="selectUni(null)">
        <span class="icon-text">
          <span class="icon">
            <i class="fa-solid fa-arrow-left"></i>
          </span>
          <span>Back to map</span>
        </span>
      </a>
  </div>
  <div class="back-button-spacer is-hidden-desktop" v-if="selectedUni"></div>

  <div class="container is-max-widescreen px-2">
    <InteractiveMap :selected-uni="selectedUni" @select-uni="selectUni" @select-uni-relative="selectUniRelative" />

    <article class="message">
      <div class="message-header">
        <p>Additional information</p>
      </div>
      <div class="message-body">
        <WhyMap />
        <References :references="links" />
        <hr>
        <References :references="siblings" />
      </div>
    </article>
  </div>
  <CustomFooter/>
</template>

<script>
import '@/country_specific/assets/css/main.scss';

import links from '@/country_specific/assets/references/links.json';
import siblings from '@/core/references/siblings.json';

import InteractiveMap from '@/country_specific/components/InteractiveMap.vue'
import WhyMap from "@/country_specific/components/WhyMap.vue";
import CustomFooter from "@/core/components/CustomFooter.vue";
import References from '@/country_specific/components/References.vue';
import {
  findInstitutionByTag,
  findInstitutionByTagAndOffset
} from "@/country_specific/assets/references/academic_institutions";

export default {
  name: 'App',
  components: {
    WhyMap,
    References,
    CustomFooter,
    InteractiveMap
  },
  data() {
    return {
      links,
      selectedUni: null,
    }
  },

  methods: {
    selectUni(uni) {
      // Jump to the top of the page when we select or deselect a uni, so that
      // the user will not be left in limbo due to the different lengths of the
      // ties.
      window.scrollTo(0, 0);

      if (!uni) {
        console.log("Redirection to full map");
        this.$router.push(`/`);
      } else if (uni?.tag === this.selectedUni?.tag) {
        console.log("Deselecting current university");
        this.$router.push(`/`);
      } else {
        console.log(`Selecting university: ${uni.tag}`);
        this.$router.push(`/${uni.tag}`);
      }
    },

    selectUniRelative(offset) {
      const uni = findInstitutionByTagAndOffset(this.selectedUni.tag, offset);
      this.selectUni(uni);
    }
  },

  computed: {
    siblings() {
      return siblings.map((sibling) => {
        return {
          href: sibling.url,
          text: `${sibling.countryName} ${sibling.flag}`
        }
      })
    }
  },

  created() {
    this.$watch(
        () => this.$route.params.uni,
        (newId) => {

          if (!newId) {
            this.selectedUni = null;
            return;
          }

          console.log(`Route changed, selecting '${newId}'`)
          this.selectedUni = findInstitutionByTag(newId);

          if(!this.selectedUni) {
            console.error(`Failed to find institution with '${newId}'`)
          }
        },
        { immediate: true }
    )
  },
}
</script>

<style scoped>
.back-button-bar {
  height: 40px;
  width: 100%;
  position: fixed;
  background: dimgrey;
  z-index: 100;
  color: white;
}

.back-button-spacer {
  height: 40px;
}

</style>